import { render } from "./PermissionIndex.vue?vue&type=template&id=6818dc4e&scoped=true"
import script from "./PermissionIndex.vue?vue&type=script&lang=js"
export * from "./PermissionIndex.vue?vue&type=script&lang=js"

import "./PermissionIndex.vue?vue&type=style&index=0&id=6818dc4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6818dc4e"

export default script